var React = require('react');

function Externallink (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"fill":"#E5E5E5"},React.createElement("path",{"d":"M1326 742v1h-5v14h14v-5h1v6h-16v-16h6zm10 0v7h-1v-5.294l-7.646 7.648-.708-.708 7.646-7.646H1329v-1h7z","transform":"translate(-1320 -742)"}))));
}

Externallink.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Externallink;

Externallink.default = Externallink;
